import { JsonObject, JsonProperty } from 'json2typescript';
import ItemChoice from '@/models/examinee/ItemChoice';

@JsonObject('ExamineeItem')
export default class ExamineeItem {
  constructor() {
    this.optionItemCode = undefined;
    this.optionItemTitle = undefined;
    this.inputType = undefined;
    this.isRequired = false;
    this.format = undefined;
    this.isValidateFail = false;
    this.value = '';
    this.displayName = '';
    this.validateMessage = undefined;
  }

  @JsonProperty('option_item_code')
  public optionItemCode?: string;

  @JsonProperty('option_item_title')
  public optionItemTitle?: string;

  @JsonProperty('input_type')
  public inputType?: string;

  @JsonProperty('is_required')
  public isRequired: boolean;

  @JsonProperty('format')
  public format?: string;

  @JsonProperty('choices')
  public choices: Array<ItemChoice> = [];

  // 内部パラメータ
  public isValidateFail: boolean;

  public value: string;

  public values: Array<string> = [];

  public displayName: string;

  public displayNames: Array<string> = [];

  public validateMessage?: string;

  public setIsValidateFail(flg: boolean) {
    this.isValidateFail = flg;
  }

  public setValidateMessage(message: string) {
    this.validateMessage = message;
  }

  public setDisplayName(str: string) {
    this.displayName = str;
  }

  public setValue(str: string) {
    this.value = str;
  }
}
